import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Aucun résultat trouvé ", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.is_open,
    onWillDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.is_open = false))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Sélectionner un travail sous-traité ")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.is_open = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Fermer ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                placeholder: "Rechercher..."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (!_ctx.first_loading && _ctx.outsourcedWorks.length)
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outsourcedWorks, (outsourcedWork) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: outsourcedWork.uuid,
                      button: true,
                      onClick: ($event: any) => (_ctx.selectOutsourcedWork(outsourcedWork))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(outsourcedWork.name) + " ", 1),
                            (outsourcedWork.reference)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(_ctx.$style['reference'])
                                }, " - " + _toDisplayString(outsourcedWork.reference), 3))
                              : _createCommentVNode("", true),
                            (outsourcedWork.contractor_name)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass(_ctx.$style['contractor'])
                                }, " (" + _toDisplayString(outsourcedWork.contractor_name) + ") ", 3))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128)),
                  _createVNode(_component_ion_infinite_scroll, {
                    hidden: _ctx.has_more_data || _ctx.loading,
                    threshold: "200px",
                    onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadOutsourcedWorks($event)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_infinite_scroll_content)
                    ]),
                    _: 1
                  }, 8, ["hidden"])
                ]),
                _: 1
              }))
            : (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass({
          'ion-padding': true,
          [_ctx.$style['no-result']]: true,
        })
                }, _hoisted_2, 2))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass({
          'ion-padding': true,
          [_ctx.$style['no-result']]: true,
        })
                  }, [
                    _createVNode(_component_ion_spinner)
                  ], 2))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}